// extracted by mini-css-extract-plugin
export default {"productCarousel":"I0-z"};